import { render, staticRenderFns } from "./goodsPackageGrade.vue?vue&type=template&id=e01c5422&"
import script from "./goodsPackageGrade.vue?vue&type=script&lang=js&"
export * from "./goodsPackageGrade.vue?vue&type=script&lang=js&"
import style0 from "./goodsPackageGrade.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports